import { IonImg } from '@ionic/react'

import type { UnlayerOneShopTemplate } from '../../custom/unlayer-templates'

type Props = { template: UnlayerOneShopTemplate }

function UnlayerTemplateDisplay({ template }: Props) {
  return (
    <div className="space-y-2">
      <div className="h-auto max-h-[600px] overflow-hidden border border-gray-700 shadow-lg">
        <IonImg
          src={template.url}
          alt={`Email template - ${template.tags[0]}`}
          className="size-full object-contain"
        />
      </div>
      <p className="px-4 pb-4 text-center text-sm text-gray-300">
        Category: {template.tags.join(', ')}
      </p>
    </div>
  )
}

export { UnlayerTemplateDisplay }
